<script setup lang="ts">
  import { Typo, TypoVariant } from '@travelata-libs/ui-kit';
  import { computed } from 'vue';
  import { formatRating, getRatingTone, type RatingTone } from '@/shared/lib/rating';

  interface RatingBadgeProps {
    rating?: number | null;
    testid?: string;
  }

  const props = withDefaults(defineProps<RatingBadgeProps>(), {
    rating: null,
    testid: undefined,
  });

  const tone = computed<RatingTone>(() => getRatingTone(props.rating));
  const label = computed<string>(() => formatRating(props.rating));
</script>

<template>
  <Typo
    :class="['rating-badge', `rating-badge_${tone}`]"
    :variant="TypoVariant.BodyMMedium"
    tag="span"
    :data-testid="testid"
  >
    {{ label }}
  </Typo>
</template>

<style scoped lang="scss">
  .rating-badge {
    border-radius: var(--rounding-xxl);
    box-sizing: border-box;
    color: var(--color-neutral-0);
    display: inline-flex;
    justify-content: center;
    min-width: 20px;
    padding: var(--spacing-xxxs) var(--spacing-xxs);

    &_excellent {
      background: var(--color-green-50);
    }

    &_good {
      background: var(--color-lime-50);
    }

    &_average {
      background: var(--color-orange-50);
    }

    &_low {
      background: var(--color-red-50);
    }

    &_none {
      background: var(--color-text-tertiary);
    }
  }
</style>
